export default function(tooltipModel) {
  let tooltipEl = document.getElementById("chartjs-tooltip")

  if (!tooltipEl) {
    tooltipEl = document.createElement("div")
    tooltipEl.id = "chartjs-tooltip"
    tooltipEl.innerHTML = `<div class="innerTooltip"></div>`
    document.body && document.body.appendChild(tooltipEl)
  }

  if (tooltipModel.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  const classes = ["background-gray-80", "white", "rounded", "py4", "px8"]

  classes.forEach(cx => {
    tooltipEl.classList.add(cx)
  })

  tooltipEl.classList.remove("above", "below", "no-transform")
  if (tooltipModel.yAlign) {
    tooltipEl.classList.add(tooltipModel.yAlign)
  } else {
    tooltipEl.classList.add("no-transform")
  }

  const getBody = bodyItem => bodyItem.lines

  if (tooltipModel.body) {
    const titleLines = tooltipModel.title || []
    const bodyLines = tooltipModel.body.map(getBody)

    let innerHtml = ``

    bodyLines.forEach((body, i) => {
      innerHtml = `<div>${body}</div>` + innerHtml
    })

    titleLines.forEach(title => {
      innerHtml = `<div class="fz11 bold">${title}</div>` + innerHtml
    })

    const tableRoot = tooltipEl.querySelector(".innerTooltip")
    tableRoot.innerHTML = innerHtml
  }

  const position = this._chart.canvas.getBoundingClientRect()

  const leftPos =
    tooltipModel.width + tooltipModel.caretX > position.width
      ? position.left + tooltipModel.caretX - tooltipModel.width - 12 + "px"
      : position.left + tooltipModel.caretX + 8 + "px"

  tooltipEl.style.opacity = 1
  tooltipEl.style.position = "absolute"
  tooltipEl.style.left = leftPos
  tooltipEl.style.top = position.top + tooltipModel.caretY + 12 + "px"
  tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily
  tooltipEl.style.fontSize = tooltipModel.bodyFontSize + "px"
  tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle
}
